import React from "react";
import { FiInfo } from "react-icons/fi";
import CommonTooltip from "./CommonTooltip";

/**
 * Small inline "i" icon that shows a translated tooltip on hover/focus.
 * By default the tooltip is CSS-only (`data-tooltip`). Pass `blueTooltip` to use the
 * shared blue CommonTooltip instead, which stays inside the viewport and flips sides
 * rather than being clipped by a scrolling modal.
 */
const FieldInfoIcon = ({ tooltipText, className = "", blueTooltip = false }) => {
  if (!tooltipText) return null;

  if (blueTooltip) {
    return (
      <CommonTooltip
        text={tooltipText}
        position="top"
        disableDefaultDescription
        tooltipClassName="w-max max-w-[min(15rem,calc(100vw-1.5rem))] [text-wrap:balance]"
        fitContent
        clampToViewport
        hoverOnly
      >
        <span
          className={`field-info-icon ${className}`}
          tabIndex={0}
          role="img"
          aria-label={tooltipText}
        >
          <FiInfo size={14} />
        </span>
      </CommonTooltip>
    );
  }

  return (
    <span
      className={`field-info-icon  ${className}`}
      data-tooltip={tooltipText}
      tabIndex={0}
      role="img"
      aria-label={tooltipText}
    >
      <FiInfo size={14} />
    </span>
  );
};

export default FieldInfoIcon;
